module.exports = __webpack_public_path__ + "media/images/card_logos/diners-logo-7f24825839705b95ce4852d98d59e45d.gif";